// extracted by mini-css-extract-plugin
export var logo = "index-module--logo--31ff1 flex items-center pointer-events-auto";
export var sChr = "index-module--sChr--55fa1 font-bb inline";
export var svg = "index-module--svg--d0ef2 w-[123px] text-orange";
export var title = "index-module--title--58b5a";